import React from 'react'
import { HiMenuAlt3, HiX } from 'react-icons/hi'

const Header = ({ setMenuOpen, menuOpen }) => {
  return (
    <>
      <nav>
        <a href="#home" className="navLogo">M<span>.</span></a>
        <div className="navLinks">
          <a href="#home">Home</a>
          <a href="#work">Projects</a>
          <a href="#timeline">Experience</a>
          <a href="#services">Skills</a>
          <a href="#contact">Contact</a>
        </div>
        <a href="https://mail.google.com/mail/?view=cm&fs=1&to=manav9330833@gmail.com" target="_blank" rel="noreferrer" className="navCta">
          Let's Talk
        </a>
      </nav>

      <button className="navBtn" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <HiX /> : <HiMenuAlt3 />}
      </button>
    </>
  )
}

export const HeaderPhone = ({ menuOpen, setMenuOpen }) => {
  return (
    <>
      {menuOpen && <div className="navOverlay" onClick={() => setMenuOpen(false)} />}
      <div className={`navPhone ${menuOpen ? "navPhoneComes" : ""}`}>
        <a href="#home" className="navLogo" onClick={() => setMenuOpen(false)}>M<span>.</span></a>
        <div className="navPhoneLinks">
          <a onClick={() => setMenuOpen(false)} href="#home">Home</a>
          <a onClick={() => setMenuOpen(false)} href="#work">Projects</a>
          <a onClick={() => setMenuOpen(false)} href="#timeline">Experience</a>
          <a onClick={() => setMenuOpen(false)} href="#services">Skills</a>
          <a onClick={() => setMenuOpen(false)} href="#contact">Contact</a>
        </div>
        <a href="https://mail.google.com/mail/?view=cm&fs=1&to=manav9330833@gmail.com" target="_blank" rel="noreferrer" className="navPhoneCta" onClick={() => setMenuOpen(false)}>
          Let's Talk →
        </a>
      </div>
    </>
  );
};

export default Header